import isColorFilter from './is-color-filter';

export const OTHERS_COLOR_FILTER = 'Others';

/**
 * Checks if the filter is the 'Others' color filter.
 *
 * @param categoryName Category name of the filter
 * @param filter Filter value
 * @returns True if the filter is the 'Others' color filter, false otherwise.
 */
export default function isOthersColorFilter(
  categoryName: string,
  filter: string
): boolean {
  return isColorFilter(categoryName) && filter === OTHERS_COLOR_FILTER;
}
